<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="付款类型"
                        prop="payment_apply_type">
            <el-select v-model="search.payment_apply_type" clearable
                       class="width-max">
              <el-option v-for="(label, key) in payment_apply_payment_type"
                         :key="key"
                         :label="label.name"
                         :value="label.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15 header">
        <div class="flex-row">
          <el-button type="primary"
                      @click="dialogVisible = true"
                      size="small">添加
          </el-button>
          <el-button type="primary"
                      icon="sj-icon-export"
                      @click="onExportAll"
                      size="small">导出科目关系
          </el-button>
          <el-button size="small"
                    type="warning"
                    icon="sj-icon-export"
                    @click="uploadDialogVisible = true">
            更新科目关系
          </el-button>
        </div>
        <div>
          <el-button type="primary"
                     @click="$router.push('/finance-config/subject-management')"
                      size="small">一级科目列表
          </el-button>
          <el-button type="primary"
                      @click="$router.push('/finance-config/second-subject-management')"
                      size="small">二级科目列表
          </el-button>
        </div>
      </div>
      <el-table ref="table"
                :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column label="ID" width="70">
          <template slot-scope="scope">
            <span size="mini">{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <template v-for="(attr, index) of relationshipFields">
          <el-table-column :key="index" v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="190">
          <template slot-scope="scope">
            <button-gutter>
              <el-button
                size="mini"
                type="success"
                @click="$router.push(`/finance-config/subject-relationships-management-form/${scope.row.id}`)">管理二级科目</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="onDelete(scope.$index, table)">删除</el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog
      title="添加科目关系"
      :visible.sync="dialogVisible">
      <el-form :model="form"
               :rules="formRules"
               ref="form"
               label-width="96px"
               label-position="right"
               size="medium">
        <div class="re-el-form__flex">
          <el-form-item label="付款类型"
                        prop="payment_apply_type">
            <el-select v-model="form.payment_apply_type" clearable
                       class="width-max">
              <el-option v-for="(label, key) in payment_apply_payment_type"
                         :key="key"
                         :label="label.name"
                         :value="label.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="一级科目"
                        prop="first_subject_id">
            <el-select v-model="form.first_subject_id" clearable
                       class="width-max">
              <el-option v-for="(label, key) in first_subject_source"
                         :key="key"
                         :label="label.name"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onCreate">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="更新科目关系"
      top="30vh"
      :visible.sync="uploadDialogVisible">
      <span>此操作会覆盖已有所有科目关系，请确认更新时上传的是完整科目关系表。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取 消</el-button>
        <el-upload
          style="margin-left: 5px; display: in"
          action
          accept=".xlsx"
          :http-request="uploadFile"
          :show-file-list='false'>
          <el-button type="primary" icon="sj-icon-export">上传文件</el-button>
        </el-upload>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchRules, formRules } from '../finance-config.rules.js'
import financelConfigMixins from '../finance-config.mixins'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import { MessageBox } from 'element-ui'

import Worker from '@/worker/read-xlsx.worker'
const worker = new Worker()
export default {
  mixins: [table, dateTimePicker, financelConfigMixins],
  data () {
    return {
      searchRules,
      search: {
        payment_apply_type: null,
        is_disabled: 0,
      },
      searchFieldType: {
        payment_apply_type: Number,
      },
      exportHeader: [
        {
          key: 'id',
          text: 'ID',
        },
        {
          key: 'payment_apply_type',
          text: '付款类型',
        },
        {
          key: 'first_subject',
          text: '一级科目',
        },
        {
          key: 'second_subject',
          text: '二级科目',
        },
      ],
      first_subject_source: {},
      second_subject_source: {},
      payment_apply_payment_type: {},
      dialogVisible: false,
      uploadDialogVisible: false,

      formRules,
      form: {
        payment_apply_type: null,
        first_subject_id: null,
        second_subject_ids: [],
      },
    }
  },
  computed: Vuex.mapState({
    // payType: state => state.paymentManager.type,
  }),
  created () {
    request.common('getFinCenterConfigs').then(({data}) => {
      this.first_subject_source = data.first_subject_source
      this.second_subject_source = data.second_subject_source
      this.payment_apply_payment_type = data.payment_apply_payment_type.reduce((o, k) => {
        if (k.id !== 5) {
          o[k.id] = k
        }
        return o
      }, {})
    })
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('subjectRelationshipLists', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onCreate () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    create () {
      request.common('createSubjectRelationship', this.getForm()).then((res) => {
        this.$message.success('添加成功')
        this.onRefresh()
        this.dialogVisible = false
        this.form = {
          payment_apply_type: null,
          first_subject_id: null,
          second_subject_ids: [],
        }
      })
    },
    toggleEnable (row) {
      this.$confirm(row.is_disabled ? '是否确定启用' : '该一级科目对应的科目关系将删除', '提示', {type: 'warning'}).then(() => {
        request.common(row.is_disabled ? 'enableSubjectSecond' : 'disableSubjectSecond', {id: row.id}).then((res) => {
          this.$message.success('更新成功')
          this.onRefresh()
        })
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('disableSubjectRelationship', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    onExportAll () {
      this.$export('科目关系', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          const tempArray = []
          for (let i = 0; i < data.data.length; i++) {
            const item = data.data[i]
            tempArray.push(...item.second_subject_ids.map(secondId => {
              return {
                id: item.id,
                payment_apply_type: this.payment_apply_payment_type[item.payment_apply_type].name,
                first_subject: this.first_subject_source[item.first_subject_id].name,
                second_subject: this.second_subject_source[secondId].name,
              }
            }))
          }
          data.data = tempArray
          return data
        },
      })
    },
    uploadFile (file) {
      worker.postMessage({file: file.file, options: {header: 1}})
      worker.onmessage = (event) => {
        const data = this.handleExcelData(event.data)
        this.uplodaData(_.values(this.recombine(data)))
      }
    },
    uplodaData (data) {
      request.common('batchEditSubjectRelationship', {subject_rel: data}).then(_ => {
        this.$message.success('更新成功')
        this.onrefresh()
      })
    },
    recombine (data) {
      const tempPaymentApplyPaymentType = this.transformMapKey(this.payment_apply_payment_type)
      const tempFirstSubjectSource = this.transformMapKey(this.first_subject_source)
      const tempSecondSubjectSource = this.transformMapKey(this.second_subject_source)
      return data.map((item, index) => {
        if (!tempPaymentApplyPaymentType[item.payment_apply_type]) {
          MessageBox.alert(`第${index + 1}行付款类型异常: ${item.payment_apply_type}`, '数据异常', {type: 'error'})
          throw new Error(`第${index + 1}行付款类型异常`)
        }
        if (!tempFirstSubjectSource[item.first_subject]) {
          MessageBox.alert(`第${index + 1}行一级科目异常: ${item.first_subject}`, '数据异常', {type: 'error'})
          throw new Error(`第${index + 1}行付款类型异常`)
        }
        if (!tempSecondSubjectSource[item.second_subject]) {
          MessageBox.alert(`第${index + 1}行二级科目异常: ${item.second_subject}`, '数据异常', {type: 'error'})
          throw new Error(`第${index + 1}行付款类型异常`)
        }
        const value = {
          payment_apply_type: tempPaymentApplyPaymentType[item.payment_apply_type].id,
          first_subject_id: tempFirstSubjectSource[item.first_subject].id,
          second_subject_id: tempSecondSubjectSource[item.second_subject].id,
        }
        return value
      }).reduce((o, k) => {
        const key = `${k.payment_apply_type}-${k.first_subject_id}`
        if (o[key]) {
          o[key].second_subject_ids.push(k.second_subject_id)
        } else {
          o[key] = {
            payment_apply_type: k.payment_apply_type,
            first_subject_id: k.first_subject_id,
            second_subject_ids: [k.second_subject_id]
          }
        }
        return o
      }, {})
    },
    transformMapKey (source) {
      const temp = {}
      _.forIn(source, (value, key) => {
        temp[value.name] = value
      })
      return temp
    },
    handleExcelData (rows) {
      let items = []
      let tableHeader = {
        id: {
          index: null,
          text: 'ID',
        },
        first_subject: {
          index: null,
          text: '一级科目',
        },
        second_subject: {
          index: null,
          text: '二级科目',
        },
        payment_apply_type: {
          index: null,
          text: '付款类型',
        },
      }
      try {
        rows.forEach((row, rowIndex) => {
          let item = {}
          row.forEach((cell, cellIndex) => {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                for (let header of Object.values(tableHeader)) {
                  if (!Number.isInteger(header.index)) {
                    this.loading = false
                    throw new Error(`找不到 [${header.text}] 表头`)
                  }
                }
              }
              // 表格的行数据获取
              for (let field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              for (let header of Object.values(tableHeader)) {
                if (cell === header.text) {
                  header.index = cellIndex
                }
              }
            }
          })
          rowIndex && items.push(item)
        })
        return items
      } catch (e) {
        this.$alert(e.toString(), '提示', {type: 'error'})
        throw new Error(e)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.dialog-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/PaymentSubjectRelationshipsManagement.vue